export const PATH_CASES          = 'cases';
export const PATH_PROFILES       = 'profiles';
export const PATH_JOBS           = 'jobs';

export const PATH_JURY           = 'about/jury';
export const PATH_PAGE           = 'page';
export const PATH_TIMELINE       = 'awards';
export const PATH_LEADERBOARD    = 'live-judging';
export const PATH_ACCOUNT        = 'account';

//Editorial paths
export const PATH_EDITORIAL      = 'editorial';
export const PATH_INTERVIEW      = 'interviews'; //ID: 4
export const PATH_ARTICLE        = 'article'; //ID: 1
export const PATH_DP             = 'digital-pioneers'; //ID: 3
export const PATH_AS             = 'agency-spotlight'; //ID: 5
export const PATH_FL             = 'fwa-legends'; //ID: 2
export const PATH_FH             = 'fwa-hero'; //ID:

import React from 'react';
import Route from 'react-router/lib/Route';
import Redirect from 'react-router/lib/Redirect';
import IndexRoute from 'react-router/lib/IndexRoute';

import slugify from 'to-slug';
import baseUrl from '../utils/baseUrl';

import con from '../containers/containers';
import { accountPages } from '../containers/containers';

import * as MenuType from '../constants/types';
import forEach from 'lodash/forEach';

export let routes = (
	<Route path={baseUrl + '/'} component={con.App} showFilter={true}>
		<Route path={PATH_TIMELINE} component={con.Timeline} showFilter={true}>
			<Route path='page/:pageNum' component={con.Timeline} showFilter={true}/>
		</Route>

		<Route path={PATH_LEADERBOARD} component={con.LiveJudging}/>

		// Resource routes
		<Route path={PATH_JURY} component={con.Jury}/>

		<Route path={PATH_CASES + '/:slug'} component={con.Case}/>

		<Route path={PATH_PROFILES} component={con.Profiles}/>
		<Route path={PATH_PROFILES + '/:slug'} component={con.ProfilePage}/>

		<Route path={PATH_JOBS} component={con.Jobs}></Route>
		<Route path={PATH_JOBS + '/:slug'} component={con.JobPage}/>

		<Redirect from={PATH_ACCOUNT} to={PATH_ACCOUNT + '/settings'} />

		<Route path={'submit/project'} component={con.SubmitCaseNotLoggedIn} />
		<Route path={'submit/job'} component={con.SubmitJobNotLoggedIn} />

		<Redirect from={'submit_site'} to={'submit/project'} />
		<Redirect from={'submit_job'} to={'submit/job'} />

		<Route path={PATH_ACCOUNT} component={con.Account} >
			<Route path={'settings'} component={accountPages.AccountBasic} />
			<Route path={'jury'} component={accountPages.AccountJury}>
				<Route path={'fotd'} component={accountPages.AccountJuryFOTD} />
				<Route path={'fotm'} component={accountPages.AccountJuryFOTM} />
				<Route path={'foty'} component={accountPages.AccountJuryFOTY} />
				<Route path={'tcea'} component={accountPages.AccountJuryTCEA} />
			</Route>

			<Redirect from={'profile'} to={'profile/settings'} />
			<Route path={'profile'}>

				<Route path={'settings'} component={accountPages.ProfileEdit} />

				<Route path={'projects'}>
					<IndexRoute component={accountPages.CaseList} />
					<Route path={'create'} component={accountPages.CaseCreate} />
					<Route path={':id'} component={accountPages.CaseEdit} />
				</Route>

				<Route path={'jobs'}>
					<IndexRoute component={accountPages.JobList} />
					<Route path={'create'} component={accountPages.JobCreate} />
					<Route path={':id'} component={accountPages.JobEdit} />
				</Route>
			</Route>


			<Route path={'editorial'} source='user'>
				<Route path={':type'} component={accountPages.ProfileEditorial} />
				<Route path={':type/:id'} component={accountPages.EditorialEdit} />
			</Route>

			<Route path={'profile/editorial'} source='profile'>
				<Route path={':type/create'} component={accountPages.EditorialEdit} />
				<Route path={':type/:id'} component={accountPages.EditorialEdit} />
				<Route path={':type'} component={accountPages.ProfileEditorial} />
			</Route>

			<Route path={'admin'}>
				<Route path={'jury-overview'} component={accountPages.AdminJuryOverview} />
			</Route>

		</Route>

		//All editorial routes delivered by CMS
		{konfig.editorialSlugs.map((item, i) => {
			if (!item) {
				return false;
			}

			return (
				<Route key={i} path={item + '/:slug'} component={con.Editorial}/>
			);
		})}

		<Route path={'/tceay'} component={con.TCEAYVote} />
		<Route path={'/pca'} component={con.PCAVote} />

		<Route path={PATH_ACCOUNT + '/login'} component={con.AccountLogin} />
		<Route path={PATH_ACCOUNT + '/logout'} component={con.AccountLogout} />
		<Route path={PATH_ACCOUNT + '/register'} component={con.AccountRegister} ></Route>
		<Route path={PATH_ACCOUNT + '/verify'} component={con.AccountActivate}>
			<Route path=':hash'></Route>
		</Route>
		<Route path={PATH_ACCOUNT + '/recover'} component={con.AccountRecover}>
			<Route path=':hash'></Route>
		</Route>

		// These paths are all editorial content
		<Route path={PATH_EDITORIAL + '/:slug'} component={con.Editorial}/>

		/*<Route path={PATH_PAGE + '/:slug'} component={con.Page}/>*/

		<Route path='error' component={con.ErrorPage} />
		/*<Route path='user/:menuactive' component={con.Timeline}/>*/
		<Route path='*' component={con.Page} />
	</Route>
);

export function genericRoute(slug, path = false, shouldSlugify = true) {
	let returnPath = baseUrl + '/';
	if (path) {
		returnPath += `${path}/`;
	}

	if (shouldSlugify && typeof slug === 'string' && slug.length > 1) {
		returnPath += slugify(slug);
	}

	return returnPath;
}

export function accountRoute(path = '') {
	return genericRoute(false, PATH_ACCOUNT + path);
}

export function awardsRoute() {
	return genericRoute('', PATH_TIMELINE);
};

export function liveRoute() {
	return genericRoute('', PATH_LEADERBOARD);
};

export function jobsRoute(slug = '') {
	return genericRoute(slug, PATH_JOBS);
};

export function interviewRoute(slug = '') {
	return genericRoute(slug, PATH_INTERVIEW);
};

export function casesRoute(slug) {
	return genericRoute(slug, PATH_CASES);
};

export function agencyRoute(slug) {
	return genericRoute(slug, PATH_AGENCIES);
};

export function profilesRoute(slug) {
	return genericRoute(slug, PATH_PROFILES);
};

export function editorialRoute(slug) {
	return genericRoute(slug, PATH_EDITORIAL);
};

export function pageRoute(path) {
	return genericRoute(false, path, false);
};

export function generateURL(type, slug) {
	switch (type) {
		case MenuType.TYPE_TIMELINE:
			return genericRoute(PATH_TIMELINE);

		case MenuType.TYPE_TIMELINE:
			return genericRoute(PATH_LEADERBOARD);

		case MenuType.TYPE_TEMPLATES:
			return pageRoute(slug);

		case MenuType.TYPE_EDITORIAL:
			return editorialRoute(slug);

		case MenuType.TYPE_INTERVIEW:
			return interviewRoute(slug);

		// Has List view...
		case MenuType.TYPE_PROFILES:
			return genericRoute(PATH_PROFILES);

		case MenuType.TYPE_JOBS:
			return genericRoute(PATH_JOBS);

		// the following get a default route
		case MenuType.TYPE_NONE:
		case MenuType.TYPE_CONTAINER:
		case MenuType.TYPE_EDITORIAL_LIST:
		default:
			return genericRoute(slug, type);
	}
};



/** WEBPACK FOOTER **
 ** ./frontend/routes/index.js
 **/